import type { ReactNode } from "react";

const TONES = {
  default: "text-app-ink",
  overdue: "text-app-overdue",
  done: "text-green-700",
  /** For a value that isn't there yet, so an em dash doesn't read as a result. */
  empty: "text-app-dim",
} as const;

interface StatTileProps {
  label: string;
  value: ReactNode;
  tone?: keyof typeof TONES;
}

/** The strip StatTiles sit in: stacked on a phone, side by side from `sm`. */
export function StatRow({ children }: { children: ReactNode }) {
  return (
    <div className="flex flex-col divide-y divide-gray-100 border-t border-gray-100 sm:flex-row sm:divide-x sm:divide-y-0">
      {children}
    </div>
  );
}

/**
 * One fact of a card: the label beside its number where the row stacks on a phone, above it once
 * the tiles sit side by side. Sits in a row of its peers — see StatRow.
 */
export function StatTile({ label, value, tone = "default" }: StatTileProps) {
  return (
    <div className="flex items-baseline justify-between gap-3 px-5 py-3 sm:block sm:flex-1 sm:py-4">
      <p className="app-label">{label}</p>
      <p className={`app-metric ${TONES[tone]} sm:mt-0.5`}>{value}</p>
    </div>
  );
}
